import { ComponentType } from 'react';
import React from 'react';
import { createIcon } from '@chakra-ui/react';

export const FigmaIcon = createIcon({
    displayName: 'FigmaIcon',
    viewBox: '0 0 14 20',
    path: <path d="M10.2,7.5h-3.8V0h3.8c2.1,0,3.7,1.7,3.7,3.7s-1.7,3.7-3.7,3.7ZM7.6,6.3h2.6c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5h-2.6v5ZM7.6,7.5h-3.8C1.7,7.5,0,5.8,0,3.7S1.7,0,3.8,0h3.8v7.5h0ZM3.8,1.2c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5h2.6V1.2h-2.6ZM7.6,13.7h-3.8C1.7,13.7,0,12.1,0,10s1.7-3.7,3.7-3.7h3.8v7.5h0ZM3.8,7.5c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5h2.6v-5h-2.6ZM3.8,20C1.7,20,0,18.3,0,16.3s1.7-3.7,3.7-3.7h3.8v3.7c0,2.1-1.7,3.8-3.8,3.8ZM3.8,13.7c-.7,0-1.3.3-1.8.7-.5.5-.7,1.1-.7,1.8,0,1.4,1.1,2.5,2.5,2.5s2.6-1.1,2.6-2.6v-2.5h-2.6ZM10.2,13.7h0c-2.1,0-3.7-1.7-3.7-3.7s1.7-3.7,3.7-3.7h0c2.1,0,3.7,1.7,3.7,3.7s-1.7,3.7-3.7,3.7ZM10.1,7.5c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5h0c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5h0Z" />,
});

export const AfterEffectsIcon = createIcon({
    displayName: 'AfterEffectsIcon',
    viewBox: '0 0 20 20',
    path: <path d="M7.1,8.9c0-.3-.2-.5-.2-.8,0-.3-.2-.5-.2-.7,0-.2-.1-.5-.2-.7h0c0,.4-.2.7-.3,1.1-.1.4-.2.8-.4,1.2-.1.4-.2.8-.4,1.2h2.1c0-.2-.1-.4-.2-.6,0-.2-.2-.5-.2-.7ZM14.3,8.7c-.5,0-.9.2-1.1.6-.1.2-.2.4-.2.6h1.8c.2,0,.4,0,.5,0,0,0,.1,0,.2,0h0c0-.2,0-.3,0-.4-.1-.5-.6-.8-1.1-.8ZM16.5.2H3.5C1.6.2,0,1.8,0,3.8v12.4c0,2,1.6,3.5,3.5,3.5h12.9c2,0,3.5-1.6,3.5-3.5V3.8c0-2-1.6-3.5-3.5-3.5ZM10.6,14h-1.7c0,0-.1,0-.1,0l-.7-2h-3.1l-.6,2c0,0,0,.1-.2.1h-1.6c0,0-.1,0,0-.2l2.7-7.7c0,0,0-.2,0-.3,0-.2,0-.4,0-.5,0,0,0,0,0,0h2.2c0,0,0,0,.1,0l3,8.5c0,0,0,.1,0,.1ZM17.1,10.7c0,.2,0,.3,0,.4,0,0,0,.1-.1.1s-.1,0-.3,0c-.1,0-.3,0-.5,0s-.4,0-.6,0h-2.6c0,.3.1.5.3.7.2.2.4.4.6.5.3.1.7.2,1.1.2.3,0,.6,0,.9,0,.3,0,.5,0,.7-.2,0,0,0,0,0,0v1.3s0,0,0,0c0,0,0,0,0,0-.3.1-.5.2-.8.2-.4,0-.8.1-1.2,0-.6,0-1.2,0-1.6-.3-.4-.2-.8-.5-1.1-.8-.3-.3-.5-.7-.6-1.1-.1-.4-.2-.8-.2-1.2s0-.9.2-1.3c.1-.4.3-.8.6-1.1.3-.3.6-.6,1-.8.4-.2.9-.3,1.4-.3.4,0,.9,0,1.3.3.3.1.6.4.9.7.2.3.4.6.5,1,.1.3.2.7.2,1s0,.4,0,.5Z" />,
});

export const InDesignIcon = createIcon({
    displayName: 'InDesignIcon',
    viewBox: '0 0 20 20',
    path: <path d="M3.54167 0.25C1.58333 0.25 0 1.83333 0 3.79167V16.2083C0 18.1667 1.58333 19.75 3.54167 19.75H16.4583C18.4167 19.75 20 18.1667 20 16.2083V3.79167C20 1.83333 18.4167 0.25 16.4583 0.25H3.54167ZM12.9667 4.525H14.6583C14.7 4.51667 14.7333 4.55 14.7417 4.58333V12.5333C14.7417 12.6833 14.75 12.85 14.7583 13.0333C14.775 13.2083 14.7833 13.375 14.7917 13.5167C14.7917 13.575 14.7667 13.625 14.7083 13.65C14.275 13.8333 13.8167 13.9667 13.35 14.05C12.9333 14.125 12.5 14.1667 12.0667 14.1667C11.45 14.175 10.8333 14.05 10.275 13.7917C9.75 13.55 9.31667 13.15 9.01667 12.6583C8.70833 12.15 8.55833 11.5167 8.55833 10.7583C8.55 10.1417 8.70833 9.53333 9.01667 9C9.33333 8.45833 9.79167 8.00833 10.3417 7.70833C10.925 7.38333 11.625 7.225 12.45 7.225C12.4917 7.225 12.55 7.225 12.625 7.23333C12.7 7.24167 12.7833 7.24167 12.8833 7.25V4.61667C12.8833 4.55833 12.9083 4.525 12.9667 4.525ZM5.525 5.24167H7.15C7.2 5.23333 7.25 5.26667 7.25833 5.325C7.26667 5.33333 7.26667 5.34167 7.26667 5.35V13.9C7.26667 13.9917 7.225 14.0333 7.15 14.0333H5.51667C5.44167 14.0333 5.40833 13.9917 5.40833 13.9V5.35C5.40833 5.275 5.45 5.24167 5.525 5.24167ZM12.3833 8.775C12.0583 8.775 11.7333 8.84167 11.4417 8.99167C11.1583 9.13333 10.9167 9.34167 10.7333 9.60833C10.55 9.875 10.4583 10.2333 10.4583 10.6667C10.45 10.9583 10.5 11.25 10.6 11.525C10.6833 11.75 10.8083 11.95 10.975 12.1167C11.1333 12.2667 11.325 12.3833 11.5417 12.45C11.7667 12.525 12 12.5583 12.2333 12.5583C12.3583 12.5583 12.475 12.55 12.5833 12.5417C12.6917 12.55 12.7917 12.5333 12.8833 12.5V8.83333C12.8083 8.81667 12.7333 8.8 12.6583 8.79167C12.5667 8.78333 12.475 8.775 12.3833 8.775Z" />,
});

export const TemplatingIcon = createIcon({
    displayName: 'TemplatingIcon',
    viewBox: '0 0 17 16',
    path: <path d="M14.0788 5.88506L10.6005 2.41124L11.7668 1.24649C12.0805 0.933163 12.466 0.776501 12.9232 0.776501C13.3804 0.776501 13.7656 0.933163 14.0788 1.24649L15.245 2.41124C15.5588 2.72456 15.7156 3.10954 15.7156 3.56618C15.7156 4.02282 15.5588 4.40753 15.245 4.72031L14.0788 5.88506ZM1.10693 15.3665V11.8927L4.78979 8.21456L0.472656 3.86207L4.33966 0L8.67726 4.35249L9.45475 3.57599L12.933 7.02938L12.1555 7.80588L16.4727 12.1584L12.6261 16L8.26805 11.6679L4.58519 15.3665H1.10693ZM5.95603 7.04981L7.51102 5.49681L6.52892 4.51596L5.54683 5.47637L4.40105 4.33206L5.36268 3.35121L4.3192 2.3295L2.78468 3.8825L5.95603 7.04981ZM12.6056 13.6909L14.1606 12.1379L13.1172 11.1162L12.1555 12.0766L10.9893 10.9323L11.9714 9.95147L10.9688 8.97063L9.41383 10.5236L12.6056 13.6909Z" />
});

export const ChevronIcon = createIcon({
    displayName: 'ChevronIcon',
    viewBox: '0 0 11 7',
    path: <path d="M.8,5.8c.1.1.3.2.5.2s.4,0,.5-.2l3.7-3.7,3.7,3.7c0,0,.2.1.2.2,0,0,.2,0,.3,0,.1,0,.2,0,.3,0,0,0,.2,0,.2-.2,0,0,.1-.2.2-.2,0,0,0-.2,0-.3,0-.1,0-.2,0-.3,0,0-.1-.2-.2-.2L6.1.5c-.1-.1-.3-.2-.5-.2s-.4,0-.5.2L.8,4.7c-.1.1-.2.3-.2.5s0,.4.2.5Z" />,
});

export const CompareIcon = createIcon({
    displayName: 'CompareIcon',
    viewBox: '0 0 40 28',
    path: <path d="M14,18H0v4h14v6l8-8-8-8v6ZM26,16v-6h14v-4h-14V0l-8,8,8,8Z" />
});

export const OverviewIcon = createIcon({
    displayName: 'OverviewIcon',
    viewBox: '0 0 384 224',
    path: (
        <>
            <path d="M383.1,112.2C337.8,60,275.2,0,192,0s-64.4,9.5-96.9,29.8C67.7,47,39.6,71.2,1,111l-1,1,6.7,6.9c55.1,56.4,102.7,105.1,185.3,105.1s71.9-11.9,108.2-36.4c30.9-20.9,57.2-47.4,78.3-68.8l5.5-5.5-.9-1.1ZM192,192c-44.1,0-80-35.9-80-80s35.9-80,80-80,80,35.9,80,80-35.9,80-80,80Z" />
            <path d="M186.4,82.8c0-6.9,2-13.4,5.5-18.8-26.5,0-47.9,21.6-47.9,48.2s21.5,48.1,47.9,48.1,48-21.5,48-48.1h0c-5.4,3.5-11.9,5.5-18.8,5.5-19.1-.1-34.7-15.7-34.7-34.9Z" />
        </>
    ),
});

export const CreativeAutomationIcon = createIcon({
    displayName: 'CreativeAutomationIcon',
    viewBox: '0 0 11 18',
    path: <path d="M3.33337 17.3334V10.6667H0.833374V0.666748H9.16671L7.50004 6.50008H10.8334L3.33337 17.3334Z" />
});

export const WorkflowAutomationIcon = createIcon({
    displayName: 'WorkflowAutomationIcon',
    viewBox: '0 0 18 16',
    path: (
        <>
            < path d="M11.5 15.5V13H8.16663V4.66667H6.49996V7.16667H0.666626V0.5H6.49996V3H11.5V0.5H17.3333V7.16667H11.5V4.66667H9.83329V11.3333H11.5V8.83333H17.3333V15.5H11.5Z" />
        </>
    ),
});

export const LibrariesIcon = createIcon({
    displayName: 'LibrariesIcon',
    viewBox: '0 0 18 16',
    path: (
        <>
            < path d="M0.5 0.5H7.16667V7.16667H0.5V0.5ZM8.83333 0.5H15.5V7.16667H8.83333V0.5ZM0.5 8.83333H7.16667V15.5H0.5V8.83333ZM11.3333 8.83333H13V11.3333H15.5V13H13V15.5H11.3333V13H8.83333V11.3333H11.3333V8.83333Z" />
        </>
    ),
});

export const EngageIcon = createIcon({
    displayName: 'EngageIcon',
    viewBox: '0 0 18 16',
    path: (
        <>
            < path d="M11.5 15.5V13H8.16663V4.66667H6.49996V7.16667H0.666626V0.5H6.49996V3H11.5V0.5H17.3333V7.16667H11.5V4.66667H9.83329V11.3333H11.5V8.83333H17.3333V15.5H11.5Z" />
        </>
    ),
});

export const AllFeaturesIcon = createIcon({
    displayName: 'AllFeaturesIcon',
    viewBox: '0 0 18 16',
    path: (
        <>
            < path d="M11.5 15.5V13H8.16663V4.66667H6.49996V7.16667H0.666626V0.5H6.49996V3H11.5V0.5H17.3333V7.16667H11.5V4.66667H9.83329V11.3333H11.5V8.83333H17.3333V15.5H11.5Z" />
        </>
    ),
});

export const MenuIcon = createIcon({
    displayName: "MenuIcon",
    viewBox: "0 0 24 24",
    path: (
        <>
            <path d="M22 18.0048C22 18.5544 21.5544 19 21.0048 19H12.9952C12.4456 19 12 18.5544 12 18.0048C12 17.4552 12.4456 17.0096 12.9952 17.0096H21.0048C21.5544 17.0096 22 17.4552 22 18.0048Z" />
            <path d="M22 12.0002C22 12.5499 21.5544 12.9954 21.0048 12.9954H2.99519C2.44556 12.9954 2 12.5499 2 12.0002C2 11.4506 2.44556 11.0051 2.99519 11.0051H21.0048C21.5544 11.0051 22 11.4506 22 12.0002Z" />
            <path d="M21.0048 6.99039C21.5544 6.99039 22 6.54482 22 5.99519C22 5.44556 21.5544 5 21.0048 5H8.99519C8.44556 5 8 5.44556 8 5.99519C8 6.54482 8.44556 6.99039 8.99519 6.99039H21.0048Z" />
        </>
    ),
});

export const CloseIcon = createIcon({
    displayName: "CloseIcon",
    viewBox: "0 0 32 32",
    path: (
        <>
            <path d="M17.459,16.014l8.239-8.194c0.395-0.391,0.395-1.024,0-1.414c-0.394-0.391-1.034-0.391-1.428,0  l-8.232,8.187L7.73,6.284c-0.394-0.395-1.034-0.395-1.428,0c-0.394,0.396-0.394,1.037,0,1.432l8.302,8.303l-8.332,8.286  c-0.394,0.391-0.394,1.024,0,1.414c0.394,0.391,1.034,0.391,1.428,0l8.325-8.279l8.275,8.276c0.394,0.395,1.034,0.395,1.428,0  c0.394-0.396,0.394-1.037,0-1.432L17.459,16.014z" />
        </>
    ),
});

export const ArticleIcon = createIcon({
    displayName: "ArticleIcon",
    viewBox: "0 0 63.4 80",
    path: (
        <>
            <path d="M48.4,59.8c.6,0,1.2.5,1.2,1.2s-.5,1.2-1.2,1.2H7.3c-.6,0-1.2-.5-1.2-1.2s.5-1.2,1.2-1.2h41.1ZM48.4,48.1h0c.3,0,.6.1.9.3.2.2.4.5.4.8s-.1.6-.4.8c-.2.2-.5.3-.9.3H7.3c-.6,0-1.1-.5-1.1-1.2s.5-1.2,1.1-1.2h41.1ZM48.4,36.4h0c.3,0,.6.1.9.3.2.2.4.5.4.8s-.1.6-.4.8c-.2.2-.5.3-.9.3H7.3c-.6,0-1.1-.5-1.1-1.2s.5-1.2,1.1-1.2h41.1ZM48.4,24.7h0c.3,0,.6.1.9.3.2.2.4.5.4.8s-.1.6-.4.8c-.2.2-.5.3-.9.3H7.3c-.6,0-1.1-.5-1.1-1.2s.5-1.2,1.1-1.2h41.1ZM48.4,13h0c.3,0,.6.1.9.3.2.2.4.5.4.8s-.1.6-.4.8c-.2.2-.5.3-.9.3H7.3c-.6,0-1.1-.5-1.1-1.2s.5-1.2,1.1-1.2h41.1ZM55.7,6.8H0s0,73.2,0,73.2h55.7V6.8h0ZM7.7,4.4h49.2c.3,0,.6.1.8.3.2.2.3.5.3.8v67.6h5.4V0H7.7v4.4ZM48.4,71.5c.3,0,.6.1.9.3.2.2.4.5.4.8s-.1.6-.4.8c-.2.2-.5.3-.9.3H7.3c-.6,0-1.1-.5-1.1-1.2s.5-1.2,1.1-1.2h41.1Z" />
        </>
    ),
});

export const PricingIcon = createIcon({
    displayName: "ArticleIcon",
    viewBox: "0 0 100 100",
    path: (
        <>
            <path d="M89,38V33a9,9,0,0,0-9-9H20a9,9,0,0,0-9,9v5Z" />
            <path d="M11,44V69a9,9,0,0,0,9,9H80a9,9,0,0,0,9-9V44ZM26,54h9a3,3,0,0,1,0,6H26a3,3,0,0,1,0-6ZM41,69H26a3,3,0,0,1,0-6H41a3,3,0,0,1,0,6Zm31,0a8,8,0,0,1-5-1.76,8,8,0,1,1,0-12.48A8,8,0,1,1,72,69Z" />
        </>
    ),
});

export const CheckIcon = createIcon({
    displayName: "CheckIcon",
    viewBox: "0 0 24 24",
    path: (
        <>
            <path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm5.707,8.707-7,7a1,1,0,0,1-1.414,0l-3-3a1,1,0,0,1,1.414-1.414L10,14.586l6.293-6.293a1,1,0,0,1,1.414,1.414Z" />
        </>
    ),
});

export const AddDocumentIcon = createIcon({
    displayName: 'AddDocumentIcon',
    viewBox: '64 64 896 896',
    path: (
        <>
            <path d="M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z" />
        </>
    ),
});

export const SitemapIcon = createIcon({
    displayName: 'Sitemap',
    viewBox: '0 0 576 512',
    path: (
        <>
            <path d="M208 80c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-8 0 0 40 152 0c30.9 0 56 25.1 56 56l0 32 8 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l8 0 0-32c0-4.4-3.6-8-8-8l-152 0 0 40 8 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l8 0 0-40-152 0c-4.4 0-8 3.6-8 8l0 32 8 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l8 0 0-32c0-30.9 25.1-56 56-56l152 0 0-40-8 0c-26.5 0-48-21.5-48-48l0-64z" />
        </>
    )
});

export const OutlineAdjustmentsIcon = createIcon({
    displayName: 'OutlineAdjustmentsIcon',
    viewBox: '0 0 24 24',
    path: (
        <>
            <path d="M14.25 6.087c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.036-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .369.128.713.349 1.003.215.283.401.604.401.959v0a.64.64 0 0 1-.657.643 48.39 48.39 0 0 1-4.163-.3c.186 1.613.293 3.25.315 4.907a.656.656 0 0 1-.658.663v0c-.355 0-.676-.186-.959-.401a1.647 1.647 0 0 0-1.003-.349c-1.036 0-1.875 1.007-1.875 2.25s.84 2.25 1.875 2.25c.369 0 .713-.128 1.003-.349.283-.215.604-.401.959-.401v0c.31 0 .555.26.532.57a48.039 48.039 0 0 1-.642 5.056c1.518.19 3.058.309 4.616.354a.64.64 0 0 0 .657-.643v0c0-.355-.186-.676-.401-.959a1.647 1.647 0 0 1-.349-1.003c0-1.035 1.008-1.875 2.25-1.875 1.243 0 2.25.84 2.25 1.875 0 .369-.128.713-.349 1.003-.215.283-.4.604-.4.959v0c0 .333.277.599.61.58a48.1 48.1 0 0 0 5.427-.63 48.05 48.05 0 0 0 .582-4.717.532.532 0 0 0-.533-.57v0c-.355 0-.676.186-.959.401-.29.221-.634.349-1.003.349-1.035 0-1.875-1.007-1.875-2.25s.84-2.25 1.875-2.25c.37 0 .713.128 1.003.349.283.215.604.401.96.401v0a.656.656 0 0 0 .658-.663 48.422 48.422 0 0 0-.37-5.36c-1.886.342-3.81.574-5.766.689a.578.578 0 0 1-.61-.58v0Z" />
        </>
    )
});


export const CameraReelsyIcon = createIcon({
    displayName: 'CameraReelsyIcon',
    viewBox: '0 -960 960 960',
    path: (
        <>
            <path d="M172.31-100q-29.83 0-51.07-21.24Q100-142.48 100-172.31v-575.38q0-29.83 21.24-51.07Q142.48-820 172.31-820H220v-43.08q0-15.69 10.62-26.3Q241.23-900 256.92-900h126.16q15.69 0 26.3 10.62Q420-878.77 420-863.08V-820h47.69q29.83 0 51.07 21.24Q540-777.52 540-747.69v7.69h320v560H539.23v7.69q0 29.83-21.01 51.07Q497.2-100 467.69-100H172.31Zm0-60h295.38q5.39 0 8.85-3.46t3.46-8.85V-240h320v-440H480v-67.69q0-5.39-3.46-8.85t-8.85-3.46H172.31q-5.39 0-8.85 3.46t-3.46 8.85v575.38q0 5.39 3.46 8.85t8.85 3.46Zm196.15-123.85h70.77v-70.76h-70.77v70.76Zm0-281.54h70.77v-70.76h-70.77v70.76Zm158.46 281.54h70.77v-70.76h-70.77v70.76Zm0-281.54h70.77v-70.76h-70.77v70.76Zm158.47 281.54h70.76v-70.76h-70.76v70.76Zm0-281.54h70.76v-70.76h-70.76v70.76ZM320-460Z" />
        </>
    )
});


export const CollectionPlayIcon = createIcon({
    displayName: 'CollectionPlayIcon',
    viewBox: '0 -960 960 960',
    path: (
        <>
            <path d="M353.08-462.31h35.38v-80h44.62q15.07 0 25.23-10.15 10.15-10.16 10.15-25.23v-44.62q0-15.07-10.15-25.23-10.16-10.15-25.23-10.15h-80v195.38Zm35.38-115.38v-44.62h44.62v44.62h-44.62Zm120.77 115.38h78.46q15.08 0 25.23-10.15 10.16-10.16 10.16-25.23v-124.62q0-15.07-10.16-25.23-10.15-10.15-25.23-10.15h-78.46v195.38Zm35.38-35.38v-124.62h43.08v124.62h-43.08Zm123.08 35.38h35.39v-80h47.69v-35.38h-47.69v-44.62h47.69v-35.38h-83.08v195.38ZM322.31-260Q292-260 271-281q-21-21-21-51.31v-455.38Q250-818 271-839q21-21 51.31-21h455.38Q808-860 829-839q21 21 21 51.31v455.38Q850-302 829-281q-21 21-51.31 21H322.31Zm0-60h455.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-455.38q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H322.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v455.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85Zm-140 200Q152-120 131-141q-21-21-21-51.31v-515.38h60v515.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h515.38v60H182.31ZM310-800v480-480Z" />
        </>
    )
});

export const StretchHorizontalIcon = createIcon({
    displayName: 'StretchHorizontalIcon',
    viewBox: '0 -960 960 960',
    path: (
        <>
            <path d="M480-93.85 323.85-250l42.77-42.77L450-209.38V-390h60v180l82.77-83.38L636.15-250 480-93.85Zm-230-230L93.85-480l155.53-155.54 42.77 42.77L209.38-510H390v60H210l83.38 82.77L250-323.85Zm460 0-42.77-42.77L750.62-450H570v-60h180l-83.38-82.77L710-636.15 866.15-480 710-323.85ZM450-570v-180.62l-83.38 83.39L323.85-710 480-866.15 636.15-710l-42.77 42.77L510-750.62V-570h-60Z" />
        </>
    )
});

export const LayoutDashboardIcon = createIcon({
    displayName: 'LayoutDashboardIcon',
    viewBox: '0 -960 960 960',
    path: (
        <>
            <path d="M60-100v-331.54h215.38V-100H60Zm312.31 0v-331.54h215.38V-100H372.31Zm312.31 0v-331.54H900V-100H684.62Zm-252.31-60h95.38v-211.54h-95.38V-160ZM60-528.46V-860h215.38v331.54H60Zm312.31 0V-860h215.38v331.54H372.31Zm312.31 0V-860H900v331.54H684.62Zm-564.62-60h95.39V-800H120v211.54Zm628.46 0H840V-800h-91.54v211.54Z" />
        </>
    )
});

export const FolderPlusIcon = createIcon({
    displayName: 'FolderPlusIcon',
    viewBox: '0 -960 960 960',
    path: (
        <>
            <path d="M142.31-220q-29.83 0-51.07-21.24Q70-262.48 70-292.31v-375.38q0-29.83 21.24-51.07Q112.48-740 142.31-740h375.38q29.83 0 51.07 21.24Q590-697.52 590-667.69v375.38q0 29.83-21.24 51.07Q547.52-220 517.69-220H142.31Zm564.03-300q-15.65 0-25.99-10.35Q670-540.69 670-556.34v-147.31q0-15.66 10.35-26Q690.69-740 706.34-740h147.31q15.66 0 26 10.35 10.35 10.34 10.35 26v147.31q0 15.65-10.35 25.99-10.34 10.35-26 10.35H706.34ZM730-580h100v-100H730v100ZM142.31-280h375.38q5.39 0 8.85-3.46t3.46-8.85v-375.38q0-5.39-3.46-8.85t-8.85-3.46H142.31q-5.39 0-8.85 3.46t-3.46 8.85v375.38q0 5.39 3.46 8.85t8.85 3.46Zm31.54-81.92h312.3L385-496.92l-75 100-55-73-81.15 108ZM706.34-220q-15.65 0-25.99-10.35-10.35-10.34-10.35-26v-147.31q0-15.65 10.35-25.99Q690.69-440 706.34-440h147.31q15.66 0 26 10.35Q890-419.31 890-403.66v147.31q0 15.66-10.35 26-10.34 10.35-26 10.35H706.34ZM730-280h100v-100H730v100Zm-600 0v-400 400Zm600-300v-100 100Zm0 300v-100 100Z" />
        </>
    )
});

export const TypeIcon = createIcon({
    displayName: 'TypeIcon',
    viewBox: '0 -960 960 960',
    path: (
        <>
            <path d="M234.77-867.61h56.46l135 339.61h-56.54l-31.92-82.54H188.23L156.31-528H99.77l135-339.61ZM229-466q37.77 0 63.88 26.12Q319-413.77 319-376q0 18.08-6.54 34.65-6.54 16.58-19.38 29.43L271.15-291 313-248.77l57-56L412.77-262l-56 56.38 56 56.62L370-107.23l-56-56-48.92 49.31q-13.47 13.46-30.73 20.19Q217.08-87 198-87q-37.38 0-62.69-26.62Q110-140.23 110-178q0-18.08 7.04-34.65 7.04-16.58 19.88-29.43l49.31-49.3-21.31-20.93q-12.84-12.84-19.88-28.92Q138-357.31 138-375q0-37.77 26.62-64.38Q191.23-466 229-466Zm0 217.77-49.92 49.31q-4.16 4.15-6.12 9.57Q171-183.92 171-178q0 12.23 8.38 21.12Q187.77-148 200-148q5.92 0 11.15-2.27 5.24-2.27 9.77-6.81l49.93-49.3L229-248.23ZM228-406q-12.23 0-20.62 8.88Q199-388.23 199-376q0 5.92 1.96 11.35 1.96 5.42 6.12 9.57l21.54 21.31 20.3-20.31q4.54-4.53 6.81-9.77Q258-369.08 258-375q0-12.62-8.69-21.81T228-406Zm33-396.31-55.23 143.62h114.46L265-802.31h-4ZM695.92-885q6.85 11.08 11.39 22.77 4.54 11.69 7.77 23.77L677.46-827h184.85v60h-57.77q-10.23 36.08-29.66 67.69-19.42 31.62-45.88 57.39 27.77 17.54 57.73 29.38 29.96 11.85 62.12 19.85l-14 58.15q-41.08-10.23-79.66-26.62-38.57-16.38-73.65-41-35.46 24-74.81 40.31-39.34 16.31-81.19 26.93l-13.77-57.39q32.31-8 63.23-19.84 30.92-11.85 59.08-29.77-25.69-26.16-44.54-57.77-18.85-31.62-28.46-67.31h-63.39v-60h161.77q-2.61-11.08-6.46-21.46t-8.46-20.46L695.92-885ZM803-446.77 845.77-405 549-108.23 506.23-150 803-446.77ZM580-428q20.77 0 35.38 14.62Q630-398.77 630-378q0 20.77-14.62 35.38Q600.77-328 580-328q-20.77 0-35.38-14.62Q530-357.23 530-378q0-20.77 14.62-35.38Q559.23-428 580-428Zm44.15-339q8 25.54 22.7 47.92 14.69 22.39 34.69 40.85 20.38-18.46 35.65-40.85 15.27-22.38 24.27-47.92H624.15ZM780-228q20.77 0 35.38 14.62Q830-198.77 830-178q0 20.77-14.62 35.38Q800.77-128 780-128q-20.77 0-35.38-14.62Q730-157.23 730-178q0-20.77 14.62-35.38Q759.23-228 780-228Z" />
        </>
    )
});

export const LayerPlusIcon = createIcon({
    displayName: 'LayerPlusIcon',
    viewBox: '0 -960 960 960',
    path: (
        <>
            <path d="M787.69-180H172.31Q142-180 121-201q-21-21-21-51.31v-455.38Q100-738 121-759q21-21 51.31-21h380.77v60H172.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v455.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h615.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-264.61h60v264.61Q860-222 839-201q-21 21-51.31 21Zm-532.3-153.08H510v-99.23H255.39v99.23Zm0-194.61H510v-99.23H255.39v99.23Zm350 194.61h99.22v-183.84h-99.22v183.84ZM160-240v-480 480Zm560-360v-80h-80v-60h80v-80h60v80h80v60h-80v80h-60Z" />
        </>
    )
});

export const FileMediaIcon = createIcon({
    displayName: 'FileMediaIcon',
    viewBox: '0 -960 960 960',
    path: (
        <>
            <path d="m490-435 215.77-145L490-725v290Zm101.08 224.23h141.69q-3.54 20.23-16.88 33.35-13.35 13.11-34.2 16.34l-444.07 54.92q-29.93 4.24-53.73-14.15-23.81-18.38-27.43-48.31l-51.07-412.76q-3.62-29.93 14.65-53.81 18.27-23.89 48.19-27.12l42.54-4.46v60l-34.46 3.85q-5.39.38-8.46 4.42-3.08 4.04-2.31 9.42l50.92 412.77q.77 5.39 4.62 8.46 3.84 3.08 9.23 2.31l360.77-45.23Zm-228-80q-30.31 0-51.31-21-21-21-21-51.31v-424.61q0-30.31 21-51.31 21-21 51.31-21h424.61Q818-860 839-839q21 21 21 51.31v424.61q0 30.31-21 51.31-21 21-51.31 21H363.08Zm0-60h424.61q5.39 0 8.85-3.46t3.46-8.85v-424.61q0-5.39-3.46-8.85t-8.85-3.46H363.08q-5.39 0-8.85 3.46t-3.46 8.85v424.61q0 5.39 3.46 8.85t8.85 3.46Zm212.3-224.61ZM218-164Z" />
        </>
    )
});

export const PaletteBoldIcon = createIcon({
    displayName: 'PaletteBoldIcon',
    viewBox: '0 -960 960 960',
    path: (
        <>
            <path d="M479.23-100q-77.77 0-146.92-29.96-69.16-29.96-120.77-81.58-51.62-51.61-81.58-120.96T100-480q0-79.15 30.77-148.5t83.58-120.65q52.8-51.31 123.54-81.08Q408.62-860 488.77-860q75 0 142.15 25.58 67.16 25.58 117.96 70.81 50.81 45.23 80.96 107.5Q860-593.85 860-521.08q0 103.85-61.73 162.46Q736.54-300 640-300h-72.46q-17.08 0-27.31 11.15Q530-277.69 530-262.46q0 18.54 15 38.54T560-178q0 39.61-21.92 58.81Q516.15-100 479.23-100Zm.77-380Zm-220 30q21.38 0 35.69-14.31Q310-478.62 310-500q0-21.38-14.31-35.69Q281.38-550 260-550q-21.38 0-35.69 14.31Q210-521.38 210-500q0 21.38 14.31 35.69Q238.62-450 260-450Zm120-160q21.38 0 35.69-14.31Q430-638.62 430-660q0-21.38-14.31-35.69Q401.38-710 380-710q-21.38 0-35.69 14.31Q330-681.38 330-660q0 21.38 14.31 35.69Q358.62-610 380-610Zm200 0q21.38 0 35.69-14.31Q630-638.62 630-660q0-21.38-14.31-35.69Q601.38-710 580-710q-21.38 0-35.69 14.31Q530-681.38 530-660q0 21.38 14.31 35.69Q558.62-610 580-610Zm120 160q21.38 0 35.69-14.31Q750-478.62 750-500q0-21.38-14.31-35.69Q721.38-550 700-550q-21.38 0-35.69 14.31Q650-521.38 650-500q0 21.38 14.31 35.69Q678.62-450 700-450ZM479.23-160q9.77 0 15.27-4.81T500-178q0-14-15-31.46t-15-54.69q0-42.77 29-69.31T570-360h70q70.62 0 115.31-41.38Q800-442.77 800-521.08q0-121.38-93.08-200.15Q613.85-800 488.77-800q-137.15 0-232.96 93T160-480q0 133 93.5 226.5T479.23-160Z" />
        </>
    )
});

export const TextFieldsIcon = createIcon({
    displayName: 'TextFieldsIcon',
    viewBox: '0 -960 960 960',
    path: (
        <>
            <path d="M291.69-171.69v-526h-200v-90.62h490.62v90.62h-200v526h-90.62Zm366 0v-320h-120v-90.62h330.62v90.62h-120v320h-90.62Z" />
        </>
    )
});


export const RuleFolderIcon = createIcon({
    displayName: 'RuleFolderIcon',
    viewBox: '0 -960 960 960',
    path: (
        <>
            <path d="M308-316.46 465.54-474 426-514.54 308-396.31l-46.23-46.23L222.46-402 308-316.46Zm282-10 54-54 54 54L736.54-365l-54-54 54-54L698-512.54l-54 54-54-54L551.46-473l54 54-54 54L590-326.46ZM178.62-168q-38.35 0-64.48-26.14Q88-220.27 88-258.62v-442.76q0-38.35 26.14-64.48Q140.27-792 178.62-792h179.23l106 106h317.53q38.35 0 64.48 26.14Q872-633.73 872-595.38v336.76q0 38.35-26.14 64.48Q819.73-168 781.38-168H178.62Zm0-66h602.76q10.77 0 17.7-6.92 6.92-6.93 6.92-17.7v-336.76q0-10.77-6.92-17.7-6.93-6.92-17.7-6.92H436.77l-106-106H178.62q-10.77 0-17.7 6.92-6.92 6.93-6.92 17.7v442.76q0 10.77 6.92 17.7 6.93 6.92 17.7 6.92ZM154-234v-492 492Z" />
        </>
    )
});

export const OutlinePuzzleIcon = createIcon({
    displayName: 'OutlinePuzzleIcon',
    viewBox: '0 0 24 24',
    path: (
        <>
            <path d="M14.25 6.087c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.036-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .369.128.713.349 1.003.215.283.401.604.401.959v0a.64.64 0 0 1-.657.643 48.39 48.39 0 0 1-4.163-.3c.186 1.613.293 3.25.315 4.907a.656.656 0 0 1-.658.663v0c-.355 0-.676-.186-.959-.401a1.647 1.647 0 0 0-1.003-.349c-1.036 0-1.875 1.007-1.875 2.25s.84 2.25 1.875 2.25c.369 0 .713-.128 1.003-.349.283-.215.604-.401.959-.401v0c.31 0 .555.26.532.57a48.039 48.039 0 0 1-.642 5.056c1.518.19 3.058.309 4.616.354a.64.64 0 0 0 .657-.643v0c0-.355-.186-.676-.401-.959a1.647 1.647 0 0 1-.349-1.003c0-1.035 1.008-1.875 2.25-1.875 1.243 0 2.25.84 2.25 1.875 0 .369-.128.713-.349 1.003-.215.283-.4.604-.4.959v0c0 .333.277.599.61.58a48.1 48.1 0 0 0 5.427-.63 48.05 48.05 0 0 0 .582-4.717.532.532 0 0 0-.533-.57v0c-.355 0-.676.186-.959.401-.29.221-.634.349-1.003.349-1.035 0-1.875-1.007-1.875-2.25s.84-2.25 1.875-2.25c.37 0 .713.128 1.003.349.283.215.604.401.96.401v0a.656.656 0 0 0 .658-.663 48.422 48.422 0 0 0-.37-5.36c-1.886.342-3.81.574-5.766.689a.578.578 0 0 1-.61-.58v0Z" />
        </>
    )
});

export const GridOnIcon = createIcon({
    displayName: 'GridOnIcon',
    viewBox: '0 -960 960 960',
    path: (
        <>
            <path d="M226-140q-36.73 0-61.36-24.64Q140-189.27 140-226v-508q0-36.72 24.64-61.36Q189.27-820 226-820h507q36.72 0 61.36 24.64T819-734v508q0 36.73-24.64 61.36Q769.72-140 733-140H226Zm0-54h125v-157H194v125q0 14 9 23t23 9Zm179 0h150v-157H405v157Zm204 0h124q14 0 23-9t9-23v-125H609v157ZM194-405h157v-150H194v150Zm211 0h150v-150H405v150Zm204 0h156v-150H609v150ZM194-609h157v-157H226q-14 0-23 9t-9 23v125Zm211 0h150v-157H405v157Zm204 0h156v-125q0-14-9-23t-23-9H609v157Z" />
        </>
    )
});


export const ExtensionIcon = createIcon({
    displayName: 'ExtensionIcon',
    viewBox: '0 -960 960 960',
    path: (
        <>
            <path d="M346-134H188q-22.73 0-38.36-15.64Q134-165.27 134-188v-146q35-13 54.5-46t19.5-72q0-39-19.5-72T134-570v-148q0-22.72 15.64-38.36Q165.27-772 188-772h150q14-38 45-61t69-23q38 0 69 23t45 61h152q22.72 0 38.36 15.64T772-718v152q38 14 61 45t23 69q0 38-23 69t-61 45v150q0 22.73-15.64 38.36Q740.72-134 718-134H558q-8-41-38-67.5T452-228q-38 0-68 26.5T346-134Zm-158-54h117q15-32 50.5-63t96.5-31q61 0 97.5 31t51.5 63h117v-186h16q35-6 51.5-29t16.5-49q0-26-16.5-49T734-530h-16v-188H530v-16q-6-35-29-51.5T452-802q-26 0-49 16.5T374-734v16H188v114q34 31 54 70t20 82q0 44.3-20 82.65Q222-331 188-302v114Zm264-264Z" />
        </>
    )
});



export const TextWrapDisabledIcon = createIcon({
    displayName: 'TextWrapDisabledIcon',
    viewBox: '0 -960 960 960',
    path: (
        <>
            <path d="M585.31-147.39 453.85-280l131.46-132.23 42.15 43.38L569.38-310h114.08q32.08 0 54.31-22.81Q760-355.61 760-387.69t-22.23-54.69Q715.54-465 683.46-465H180v-60h503.46q57.23 0 96.88 40.04Q820-444.92 820-387.69t-39.66 97.46Q740.69-250 683.46-250H569.38l58.08 59.23-42.15 43.38ZM180-250v-60h176.15v60H180Zm0-430v-60h601.15v60H180Z" />
        </>
    )
});


export const TypographyIcon = createIcon({
    displayName: 'TypographyIcon',
    viewBox: '0 -960 960 960',
    path: (
        <>
            <path d="M234.77-867.61h56.46l135 339.61h-56.54l-31.92-82.54H188.23L156.31-528H99.77l135-339.61ZM229-466q37.77 0 63.88 26.12Q319-413.77 319-376q0 18.08-6.54 34.65-6.54 16.58-19.38 29.43L271.15-291 313-248.77l57-56L412.77-262l-56 56.38 56 56.62L370-107.23l-56-56-48.92 49.31q-13.47 13.46-30.73 20.19Q217.08-87 198-87q-37.38 0-62.69-26.62Q110-140.23 110-178q0-18.08 7.04-34.65 7.04-16.58 19.88-29.43l49.31-49.3-21.31-20.93q-12.84-12.84-19.88-28.92Q138-357.31 138-375q0-37.77 26.62-64.38Q191.23-466 229-466Zm0 217.77-49.92 49.31q-4.16 4.15-6.12 9.57Q171-183.92 171-178q0 12.23 8.38 21.12Q187.77-148 200-148q5.92 0 11.15-2.27 5.24-2.27 9.77-6.81l49.93-49.3L229-248.23ZM228-406q-12.23 0-20.62 8.88Q199-388.23 199-376q0 5.92 1.96 11.35 1.96 5.42 6.12 9.57l21.54 21.31 20.3-20.31q4.54-4.53 6.81-9.77Q258-369.08 258-375q0-12.62-8.69-21.81T228-406Zm33-396.31-55.23 143.62h114.46L265-802.31h-4ZM695.92-885q6.85 11.08 11.39 22.77 4.54 11.69 7.77 23.77L677.46-827h184.85v60h-57.77q-10.23 36.08-29.66 67.69-19.42 31.62-45.88 57.39 27.77 17.54 57.73 29.38 29.96 11.85 62.12 19.85l-14 58.15q-41.08-10.23-79.66-26.62-38.57-16.38-73.65-41-35.46 24-74.81 40.31-39.34 16.31-81.19 26.93l-13.77-57.39q32.31-8 63.23-19.84 30.92-11.85 59.08-29.77-25.69-26.16-44.54-57.77-18.85-31.62-28.46-67.31h-63.39v-60h161.77q-2.61-11.08-6.46-21.46t-8.46-20.46L695.92-885ZM803-446.77 845.77-405 549-108.23 506.23-150 803-446.77ZM580-428q20.77 0 35.38 14.62Q630-398.77 630-378q0 20.77-14.62 35.38Q600.77-328 580-328q-20.77 0-35.38-14.62Q530-357.23 530-378q0-20.77 14.62-35.38Q559.23-428 580-428Zm44.15-339q8 25.54 22.7 47.92 14.69 22.39 34.69 40.85 20.38-18.46 35.65-40.85 15.27-22.38 24.27-47.92H624.15ZM780-228q20.77 0 35.38 14.62Q830-198.77 830-178q0 20.77-14.62 35.38Q800.77-128 780-128q-20.77 0-35.38-14.62Q730-157.23 730-178q0-20.77 14.62-35.38Q759.23-228 780-228Z" />
        </>
    )
});

export const GlobeIcon = createIcon({
    displayName: 'GlobeIcon',
    viewBox: '0 0 512 512',
    path: (
        <path d="M266.3 48.3L232.5 73.6c-5.4 4-8.5 10.4-8.5 17.1l0 9.1c0 6.8 5.5 12.3 12.3 12.3c2.4 0 4.8-.7 6.8-2.1l41.8-27.9c2-1.3 4.4-2.1 6.8-2.1l1 0c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8l-19.9 19.9c-5.8 5.8-12.9 10.2-20.7 12.8l-26.5 8.8c-5.8 1.9-9.6 7.3-9.6 13.4c0 3.7-1.5 7.3-4.1 10l-17.9 17.9c-6.4 6.4-9.9 15-9.9 24l0 4.3c0 16.4 13.6 29.7 29.9 29.7c11 0 21.2-6.2 26.1-16l4-8.1c2.4-4.8 7.4-7.9 12.8-7.9c4.5 0 8.7 2.1 11.4 5.7l16.3 21.7c2.1 2.9 5.5 4.5 9.1 4.5c8.4 0 13.9-8.9 10.1-16.4l-1.1-2.3c-3.5-7 0-15.5 7.5-18l21.2-7.1c7.6-2.5 12.7-9.6 12.7-17.6c0-10.3 8.3-18.6 18.6-18.6l29.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-20.7 0c-7.2 0-14.2 2.9-19.3 8l-4.7 4.7c-2.1 2.1-3.3 5-3.3 8c0 6.2 5.1 11.3 11.3 11.3l11.3 0c6 0 11.8 2.4 16 6.6l6.5 6.5c1.8 1.8 2.8 4.3 2.8 6.8s-1 5-2.8 6.8l-7.5 7.5C386 262 384 266.9 384 272s2 10 5.7 13.7L408 304c10.2 10.2 24.1 16 38.6 16l7.3 0c6.5-20.2 10-41.7 10-64c0-111.4-87.6-202.4-197.7-207.7zm172 307.9c-3.7-2.6-8.2-4.1-13-4.1c-6 0-11.8-2.4-16-6.6L396 332c-7.7-7.7-18-12-28.9-12c-9.7 0-19.2-3.5-26.6-9.8L314 287.4c-11.6-9.9-26.4-15.4-41.7-15.4l-20.9 0c-12.6 0-25 3.7-35.5 10.7L188.5 301c-17.8 11.9-28.5 31.9-28.5 53.3l0 3.2c0 17 6.7 33.3 18.7 45.3l16 16c8.5 8.5 20 13.3 32 13.3l21.3 0c13.3 0 24 10.7 24 24c0 2.5 .4 5 1.1 7.3c71.3-5.8 132.5-47.6 165.2-107.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM187.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6z" />
    )
});

export const LinkedIcon = createIcon({
    displayName: 'LinkedIcon',
    viewBox: '0 -960 960 960',
    path: (
        <>
            <path d="M212.31-180Q182-180 161-201q-21-21-21-51.31v-535.38Q140-818 161-839q21-21 51.31-21h535.38Q778-860 799-839q21 21 21 51.31v274.77q-7.31-1.23-14.12-1.85-6.8-.61-14.73-.61H760v-272.31q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H212.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v535.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h118.61q3.23 16.61 8 31.42 4.77 14.81 12.31 28.58H212.31ZM200-280v40-560 520Zm90-50h42.85q9.15-42.46 32.3-78.58Q388.31-444.69 423-470H290v140Zm0-240h140v-140H290v140Zm270 430q-57.92 0-98.96-41.04Q420-222.08 420-280q0-57.92 41.04-98.96Q502.08-420 560-420h76.15v60H560q-33 0-56.5 23.5T480-280q0 33 23.5 56.5T560-200h76.15v60H560Zm-30-430h140v-140H530v140Zm30 320v-60h240v60H560Zm163.85 110v-60H800q33 0 56.5-23.5T880-280q0-33-23.5-56.5T800-360h-76.15v-60H800q57.92 0 98.96 40.73Q940-338.54 940-280q0 57.92-41.04 98.96Q857.92-140 800-140h-76.15Z" />
        </>
    )
});

export const TextTuningIcon = createIcon({
    displayName: 'TextTuningIcon',
    viewBox: '0 -960 960 960',
    path: (
        <>
            <path d="M450-100v-220h60v80h310v60H510v80h-60Zm-310-80v-60h222.31v60H140Zm137.39-212.31H340l43.23-121.84h194.15L620-392.31h62.61L510.31-860h-60.62l-172.3 467.69Zm124.46-175.07L478-782.92h4l76.15 215.54h-156.3Z" />
        </>
    )
});



// Map of icon names to icon components
export const iconMap: Record<string, ComponentType> = {
    FigmaIcon,
    AfterEffectsIcon,
    InDesignIcon,
    TemplatingIcon,
    ChevronIcon,
    CompareIcon,
    OverviewIcon,
    CreativeAutomationIcon,
    WorkflowAutomationIcon,
    LibrariesIcon,
    EngageIcon,
    AllFeaturesIcon,
    MenuIcon,
    CloseIcon,
    ArticleIcon,
    PricingIcon,
    CheckIcon,
    AddDocumentIcon,
    SitemapIcon,
    OutlineAdjustmentsIcon,
    CameraReelsyIcon,
    CollectionPlayIcon,
    StretchHorizontalIcon,
    LayoutDashboardIcon,
    FolderPlusIcon,
    TypeIcon,
    LayerPlusIcon,
    FileMediaIcon,
    PaletteBoldIcon,
    TextFieldsIcon,
    RuleFolderIcon,
    OutlinePuzzleIcon,
    GridOnIcon,
    ExtensionIcon,
    TextWrapDisabledIcon,
    TypographyIcon,
    GlobeIcon,
    LinkedIcon,
    TextTuningIcon,
};

